import { useEffect, useState } from "react";
import { toast } from "sonner";
import { http } from "@/lib/api";
import { PLAYLIST_EVENT } from "@/components/MusicPlayer";

export const PlaylistSetting = () => {
  const [url, setUrl] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    http.get("/settings/playlist").then((r) => setUrl(r.data?.url ?? "")).catch(() => {});
  }, []);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await http.put("/owner/playlist", { url });
      window.dispatchEvent(new CustomEvent(PLAYLIST_EVENT, { detail: data?.url ?? "" }));
      toast.success(data?.url ? "Playlist saved! Look for the Music button." : "Playlist removed.");
    } catch (e) {
      toast.error(e?.response?.data?.detail ?? "Couldn't save the playlist.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="mt-8 rounded-[22px] border border-purple-200/20 bg-[#170a24]/80 p-5 max-w-2xl" data-testid="owner-playlist">
      <p className="font-display text-2xl">Site music</p>
      <p className="mt-1 text-sm text-purple-100/85">Paste a Spotify or YouTube playlist link. It plays from the Music button on every page.</p>
      <div className="mt-4 flex flex-col sm:flex-row gap-3">
        <input value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://open.spotify.com/playlist/..."
          data-testid="owner-playlist-input"
          className="flex-1 rounded-xl border border-purple-200/30 bg-black/30 px-4 py-2.5 text-purple-50 focus:outline-none focus:border-amber-200/60" />
        <button onClick={save} disabled={busy} data-testid="owner-playlist-save-btn"
          className="rounded-full bg-purple-100 text-[#0e0616] px-6 py-2.5 text-sm font-medium hover:bg-amber-200 transition-colors disabled:opacity-60">
          {busy ? "Saving…" : "Save"}
        </button>
      </div>
    </div>
  );
};
